export default "/imgs/investigation-02-mob.png"